module.exports = "<template> <div show.bind=show> <slot></slot> </div> </template> ";